export default {
    book: 'Reservar {product}',
    age_limit: 'Solo mayores de {age} años',
    change_plan: "Cambiar plan",
    upgrade_product: 'Mejorar producto',
    upgrade: "Mejora",
    cancel_upgrade: "Cancelar actualización",
    choose_product: 'Elegir {product}',
    days: '{count} día | {count} días',
    login_register: "Iniciar sesión/Registrarse",
    current: "Actual",
    keyless_benefits: {
        label: 'Directo al coche {0}',
        highlight: 'rental service™',
        list: {
            cant_lose_the_key: 'Seguro completo',
            zero_excess: 'Exceso cero',
            phone_as_a_key: 'El teléfono como llave',
            straight_to_car: 'Sin espera',
            no_queues: 'Sin colas',
            online_id_check: 'Verificación de identificación en línea',
            self_checkout: 'Entréguelo usted mismo',
        },
    },
}
